import { Card } from '../components/Card';
import { useContent } from '../data/ContentContext';
import './pages.css';

export function SqmDataHubPage() {
  const { modules } = useContent();
  return (
    <div className="page">
      <Card title="SQM Data Hub" icon="🗄️">
        <p>
          The SQM Data Hub brings together the focused capabilities that power
          supplier quality management end to end.
        </p>
      </Card>

      <div className="page__grid">
        {modules.map((module) => (
          <div className="feature-tile" key={module.title}>
            <div className="feature-tile__icon" aria-hidden>
              {module.icon}
            </div>
            <h3 className="feature-tile__title">{module.title}</h3>
            <p className="feature-tile__desc">{module.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
